module.exports = __webpack_public_path__ + "img/love_potion_gift.11bdb884.svg";